import { render, staticRenderFns } from "./VerifyDomainDialog.vue?vue&type=template&id=5773ebef&"
import script from "./VerifyDomainDialog.vue?vue&type=script&lang=js&"
export * from "./VerifyDomainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports